"use client";

import React, { type PropsWithChildren, useMemo, useState } from "react";

import dappConfig from "@/../config/dapp.config";

import { usePathname } from "next/navigation";
import { useCookies } from "next-client-cookies";
import { twMerge } from "tailwind-merge";

import { type SupUiTheme, ThemeProvider } from "@/hooks/useTheme";

export function BodyContext({ children }: PropsWithChildren) {
  const currentPath = usePathname();

  const { get, set } = useCookies();
  const [theme, setTheme] = useState<SupUiTheme>(() => (get(dappConfig.themeCookieName) as SupUiTheme | undefined) ?? dappConfig.defaultTheme);

  const themeContext = useMemo(
    () => ({
      theme,
      toggleTheme: (theme: SupUiTheme) => {
        setTheme(theme);
        set(dappConfig.themeCookieName, theme);
      },
    }),
    [set, theme]
  );

  const { dataTheme, isHome } = useMemo(() => {
    return {
      isHome: currentPath === "/",
      dataTheme: theme,
    };
  }, [currentPath, theme]);

  return (
    <ThemeProvider value={themeContext}>
      <body className={twMerge("bg-neutral text-neutral-900", isHome ? "bg-neutral-25" : "h-screen")} data-theme={dataTheme} suppressHydrationWarning={true}>
        {children}
      </body>
    </ThemeProvider>
  );
}
